<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Schools</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button
            class="btn add-btn"
            @click="$router.push({ name: 'schoolAdd' })"
          >
            <i class="fa fa-plus"></i>Add School
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>School Name</label>
          <input
            type="text"
            placeholder="Search Name Here"
            class="form-control"
            maxlength="100"
            v-model="name"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Status (Filter)</label>
          <select class="form-control" v-model="status">
            <option value>All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary filter-btn" @click="search">View</button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">S/N</th>
                <th class="logo-col">Logo 1</th>
                <th class="code-col">
                  <button class="btn p-0" @click="setSortBy('code')">
                    Code
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'code'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'code_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="name-col">
                  <button class="btn p-0" @click="setSortBy('name')">
                    Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="admin-col">
                  <button class="btn p-0" @click="setSortBy('admin')">
                    Admin
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'admin'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'admin_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="contact-col">
                  <button class="btn p-0" @click="setSortBy('contactNumber')">
                    Contact Number
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'contactNumber'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'contactNumber_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="status-col">
                  <button class="btn p-0" @click="setSortBy('status')">
                    Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'status'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'status_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(school, i) in schools" :key="school.Id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td class="logo-col">
                  <img
                    v-if="school.Logo1"
                    :src="school.Logo1"
                    style="width: 60%"
                  />
                </td>
                <td class="code-col">{{ school.Code }}</td>
                <td class="name-col">{{ school.Name }}</td>
                <td class="admin-col">{{ school.Admin }}</td>
                <td class="contact-col">{{ school.ContactNumber }}</td>
                <td class="status-col">{{ school.Status }}</td>
                <td class="action-col">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name: 'schoolShow',
                            params: { id: school.Id },
                          })
                        "
                      >
                        <i class="far fa-file-alt mr-2"></i>View
                      </button>
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name: 'schoolEdit',
                            params: { id: school.Id },
                          })
                        "
                      >
                        <i class="fa fa-pencil mr-2"></i>Edit
                      </button>
                      <button
                        class="dropdown-item"
                        @click="deleteSchool(school.Id)"
                      >
                        <i class="fa fa-trash-o mr-2"></i>Delete
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="schools && !schools.length">
                <td colspan="8" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="schools && schools.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          schools.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import $ from "jquery";
export default {
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      name: "",
      status: "",
      schools: [],
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Token;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getSchoolList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    search() {
      //set the state from filter
      this.$store.state.schoolFilter.schoolName = this.name;
      this.$store.state.schoolFilter.status = this.status;
      this.paging.CurrentPage = 1;
      this.getSchoolList();
    },
    deleteSchool(schoolId) {
      let param = {
        Token: this.token,
        Id: schoolId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the school?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.school
            .deleteSchool(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.paging.CurrentPage = 1;
                this.getSchoolList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getSchoolList() {
      let param = {
        Token: this.token,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        Name: this.name,
        Status: this.status,
      };
      this.$store.state.isLoading = true;
      API.school
        .getSchoolList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.schools = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getSchoolList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getSchoolList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getSchoolList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getSchoolList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getSchoolList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "code":
          if (this.paging.SortBy === "code") {
            this.paging.SortBy = "code_desc";
          } else if (this.paging.SortBy === "code_desc") {
            this.paging.SortBy = "code";
          } else {
            this.paging.SortBy = "code";
          }
          break;
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "admin":
          if (this.paging.SortBy === "admin") {
            this.paging.SortBy = "admin_desc";
          } else if (this.paging.SortBy === "admin_desc") {
            this.paging.SortBy = "admin";
          } else {
            this.paging.SortBy = "admin";
          }
          break;
        case "contactNumber":
          if (this.paging.SortBy === "contactNumber") {
            this.paging.SortBy = "contactNumber_desc";
          } else if (this.paging.SortBy === "contactNumber_desc") {
            this.paging.SortBy = "contactNumber";
          } else {
            this.paging.SortBy = "contactNumber";
          }
          break;
        case "status":
          if (this.paging.SortBy === "status") {
            this.paging.SortBy = "status_desc";
          } else if (this.paging.SortBy === "status_desc") {
            this.paging.SortBy = "status";
          } else {
            this.paging.SortBy = "status";
          }
          break;
      }
      this.getSchoolList();
    },
  },
  created() {
    //populate the filter from state
    let schoolFilter = this.$store.state.schoolFilter;
    this.name = schoolFilter.schoolName;
    this.status = schoolFilter.status;
    this.getSchoolList();
  },
};
</script>

<style scoped>
.logo-col {
  width: 150px;
}
.code-col {
  width: 150px;
}
.name-col {
  width: 300px;
}
.admin-col {
  width: 200px;
}
.contact-col {
  width: 190px;
}
.status-col {
  width: 90px;
}
</style>


// WEBPACK FOOTER //
// src/components/MainAdmin/SchoolList.vue